// Desktop

const welcomeCell1 = [
  '/images/pages/home/grids/welcome_grid/walking_over_text',
  '/images/pages/home/grids/welcome_grid/scrapbook_studio',
  '/images/pages/home/grids/welcome_grid/people_painting'
];

const welcomeCell2 = [
  '/images/pages/home/grids/welcome_grid/woman_looking_through_rack',
  '/images/pages/home/grids/welcome_grid/bar_seating',
  '/images/pages/home/grids/welcome_grid/people_on_big_steps'
];

const welcomeCell3 = [
  '/images/pages/home/grids/welcome_grid/woman_giving_presentation',
  '/images/pages/home/grids/welcome_grid/oyster_bar',
  '/images/pages/home/grids/welcome_grid/blurry_man_in_restaurant'
];

const welcomeCell4 = [
  '/images/pages/home/grids/welcome_grid/big_tree_crowd',
  '/images/pages/home/grids/welcome_grid/wicker_seating_area',
  '/images/pages/home/grids/welcome_grid/women_looking_through_shelves'
];

const welcomeGrid = [welcomeCell1, welcomeCell2, welcomeCell3, welcomeCell4];

const communityCell1 = [
  '/images/pages/home/grids/community_grid/exercise_class',
  '/images/pages/home/grids/community_grid/man_with_earrings_shopping',
  '/images/pages/home/grids/community_grid/restaurant_interior'
];

const communityCell2 = [
  '/images/pages/home/grids/community_grid/people_on_street',
  '/images/pages/home/grids/community_grid/big_game_of_chess',
  '/images/pages/home/grids/community_grid/people_outside_building'
];

const communityCell3 = [
  '/images/pages/home/grids/community_grid/kids_smelling_flowers',
  '/images/pages/home/grids/community_grid/men_cooking',
  '/images/pages/home/grids/community_grid/workout_class'
];

const communityCell4 = [
  '/images/pages/home/grids/community_grid/dj_playing_music',
  '/images/pages/home/grids/community_grid/outside_festival',
  '/images/pages/home/grids/community_grid/woman_painting_building'
];

const communityGrid = [communityCell1, communityCell2, communityCell3, communityCell4];

const workspacesCell1 = [
  '/images/pages/home/grids/workspaces_grid/conference_room_presentation',
  '/images/pages/home/grids/workspaces_grid/big_globe_light',
  '/images/pages/home/grids/workspaces_grid/four_people_meeting'
];

const workspacesCell2 = [
  '/images/pages/home/grids/workspaces_grid/casual_conference_room',
  '/images/pages/home/grids/workspaces_grid/lounging_area',
  '/images/pages/home/grids/workspaces_grid/work_cafe_chat'
];

const workspacesCell3 = [
  '/images/pages/home/grids/workspaces_grid/clean_kitchen',
  '/images/pages/home/grids/workspaces_grid/person_on_laptop',
  '/images/pages/home/grids/workspaces_grid/wicker_area_conversation'
];

const workspacesCell4 = [
  '/images/pages/home/grids/workspaces_grid/private_office_conversation',
  '/images/pages/home/grids/workspaces_grid/back_to_back_office',
  '/images/pages/home/grids/workspaces_grid/leather_couch_lounge'
];

const workspacesGrid = [workspacesCell1, workspacesCell2, workspacesCell3, workspacesCell4];

// Mobile

const welcomeRotatingImages = [
  '/images/pages/home/grids/welcome_grid/walking_over_text',
  '/images/pages/home/grids/welcome_grid/scrapbook_studio',
  '/images/pages/home/grids/welcome_grid/people_painting'
];

const communityRotatingImages = [
  '/images/pages/home/grids/workspaces_grid/casual_conference_room',
  '/images/pages/home/grids/workspaces_grid/lounging_area',
  '/images/pages/home/grids/workspaces_grid/work_cafe_chat'
];

const workspacesRotatingImages = [
  '/images/pages/home/grids/workspaces_grid/casual_conference_room',
  '/images/pages/home/grids/workspaces_grid/lounging_area',
  '/images/pages/home/grids/workspaces_grid/work_cafe_chat'
];

export {
  welcomeGrid,
  communityGrid,
  workspacesGrid,
  welcomeRotatingImages,
  communityRotatingImages,
  workspacesRotatingImages
};
